import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, MessageCircle, Mail, Phone, MapPin } from "lucide-react";
import { CONTACT } from "../data/mock";

export const Footer = () => (
  <footer className="bg-[#1A1014] text-[#F3EFE9]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
      <div className="mb-16">
        <p className="uppercase text-xs tracking-[0.2em] text-[#D4A24C] font-semibold mb-4">Ready to grow?</p>
        <h2 className="font-heading text-4xl sm:text-6xl font-light leading-tight max-w-3xl">
          Let's build your digital edge, together.
        </h2>
        <a
          href={`mailto:${CONTACT.email}`}
          data-testid="footer-email-cta"
          className="inline-flex items-center gap-2 mt-8 rounded-full bg-[#6C0B1B] text-white px-7 py-3.5 font-medium hover:bg-[#8C1126] transition-colors duration-200"
        >
          <Mail size={17} /> {CONTACT.email}
        </a>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 border-t border-white/10 pt-12">
        <div className="md:col-span-4">
          <Link to="/" data-testid="footer-logo" className="inline-block" aria-label="Levaze home">
            <img src="/logo-levaze.png" alt="Levaze" className="h-12 w-auto object-contain" />
          </Link>
          <p className="mt-3 text-sm text-[#F3EFE9]/60 leading-relaxed max-w-xs">
            Digital solutions crafted for small and medium businesses. Visibility, leads and sustainable growth.
          </p>
          <div className="flex gap-3 mt-5">
            {[
              { Icon: Facebook, href: "https://www.facebook.com/", id: "facebook" },
              { Icon: Instagram, href: "https://www.instagram.com/", id: "instagram" },
              { Icon: Twitter, href: "https://x.com/", id: "twitter" },
              { Icon: MessageCircle, href: CONTACT.whatsapp, id: "whatsapp" },
            ].map(({ Icon, href, id }) => (
              <a key={id} href={href} target="_blank" rel="noreferrer" data-testid={`footer-social-${id}`}
                className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-[#F3EFE9]/70 hover:text-white hover:border-[#D4A24C] transition-colors duration-200">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
        <div className="md:col-span-2">
          <p className="text-sm font-semibold text-white mb-4">Pages</p>
          <div className="flex flex-col gap-2.5 text-sm text-[#F3EFE9]/60">
            {["About", "Services", "Portfolio", "Team", "Contact"].map((p) => (
              <Link key={p} to={`/${p.toLowerCase()}`} className="hover:text-[#D4A24C] transition-colors duration-200">{p}</Link>
            ))}
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="text-sm font-semibold text-white mb-4">Contact</p>
          <div className="flex flex-col gap-3 text-sm text-[#F3EFE9]/60">
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-contact-email" className="flex items-center gap-2 hover:text-[#D4A24C] transition-colors duration-200">
              <Mail size={14} /> {CONTACT.email}
            </a>
            <a href={CONTACT.phoneLink} data-testid="footer-contact-phone" className="flex items-center gap-2 hover:text-[#D4A24C] transition-colors duration-200">
              <Phone size={14} /> {CONTACT.phone}
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="text-sm font-semibold text-white mb-4">Offices</p>
          <div className="flex flex-col gap-3 text-xs text-[#F3EFE9]/55 leading-relaxed">
            {CONTACT.addresses.map((a) => (
              <p key={a.label} className="flex gap-2"><MapPin size={13} className="shrink-0 mt-0.5 text-[#D4A24C]" /> {a.text}</p>
            ))}
          </div>
        </div>
      </div>
      <p className="mt-14 pt-6 border-t border-white/10 text-xs text-[#F3EFE9]/40">
        © {new Date().getFullYear()} Levaze Digital. All rights reserved.
      </p>
    </div>
  </footer>
);
